import { render, staticRenderFns } from "./IncompleteProfile.vue?vue&type=template&id=4be4468a&"
import script from "./IncompleteProfile.vue?vue&type=script&lang=js&"
export * from "./IncompleteProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports